import axios from "axios";

export const API_BASE = "https://zeeno-api-hwgzgabpbeegdvfr.eastus2-01.azurewebsites.net";
//export const API_BASE = "http://localhost:3001";
export const DOLPHIN_BASE = "https://dolphin-ocean-api-1.servicebus.windows.net";

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
});

export const dolphin = axios.create({
    baseURL: DOLPHIN_BASE,
    timeout: 15000,
    // Intentionally no default Authorization header
});




// robot-authenticate triggers dolphin_api_key refresh from dolphin
export async function refreshDolphinAPIKey(practiceId, robotSN) {
    return api.post("/robot-authenticate", {
        practiceId,
        robotSN,
    });
}


export async function refreshIntegrationPracticeCache(robotSN) {
    return api.post("/bot-appointments", {
        robotSN,
    });
}


export async function putGpsStatus({
    practiceId,
    token,             // Bearer token for this practice/robot
    appointmentId,
    gpsStatusId,
    timeout = 15000,
}) {
    return dolphin.put(
        `/${encodeURIComponent(practiceId)}/dapi/AppointmentGpsStatus`,
        null, // no body
        {
            params: { appointmentId, gpsStatusId }, // axios will encode
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
            timeout,
            // Let callers inspect non-2xx statuses without throwing:
            validateStatus: () => true,
        }
    );
}
